import * as actionTypes from "./constants";

const initialState = {
  processing: false,
  error: false,
};

export default function userManagementReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.FETCH_CURRENCY_SUCCESS_ACTION:
      return {
        ...state,
        currencyList: action.payload.rows,
      };

    case actionTypes.FETCH_MYPLAN_SUCCESS_ACTION:
      return {
        ...state,
        processing: false,
        planList: action.payload.rows,
        planCount: action.payload.count,
      };
    case actionTypes.FETCH_MYPLAN_ACTION:
      return {
        ...state,
        processing: true,
      };
    case actionTypes.FETCH_PLAN_CARGOSIZE_SUCCESS_ACTION:
      return {
        ...state,
        plancargoSize: action.payload.rows.filter(function (plancargoSize) {
          return plancargoSize.name === "Small";
        }),
      };
    case actionTypes.FETCH_PLAN_CARGOSIZELIST_SUCCESS_ACTION:
      return {
        ...state,
        planCargoList: action.payload.rows,
      };
    default:
      return {
        ...state,
      };
  }
}
